import { buildTheme } from './DefaultBaseTheme';

export const Colors = {
    strokeColor: '#555',
    defaultFillColor: '#fff',
    textColor: '#333',
    arrowFillColor: '#444',
    rectangleFillColor: '#bbdefb',
    rectangleDotFillColor: '#ede7f6',
    functionFillColor: '#c8e6c9',
    rootCircleFillColor: '#fff9c4',
    loopFillColor: '#d1c4e9',
    conditionFillColor: '#e1bee7',
    destructedNodeFillColor: '#ffecb3',
    classFillColor: '#b2dfdb',
    debuggerFillColor: '#ffcdd2',
    exportFillColor: '#b3e5fc',
    throwFillColor: '#ffccbc',
    tryFillColor: '#FFE082',
    objectFillColor: '#d1c4e9',
    callFillColor: '#dcedc8',
    debugModeFillColor: '#666'
};

export default buildTheme(Colors);
